import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const cMTypesApi = createApi({
  reducerPath: 'cMTypesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CampaignTypes'],
  endpoints: builder => ({
    getCampaignTypes: builder.query({
      query: (params) => ({
        url: `/campaigns/campaign-type/`,
        params,
      }),
      providesTags: ['CampaignTypes']
    }),
    createCampaignType: builder.mutation({
      query: body => ({
        url: '/campaigns/campaign-type/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['CampaignTypes']
    }),
    getCampaignTypeById: builder.query({
      query: id => ({
        url: `/campaigns/campaign-type/${id}/`,
        method: 'GET'
      }),
      providesTags: ['CampaignTypes']
    }),
    
    updateCampaignType: builder.mutation({
      query: ({ id, body }) => ({
        url: `/campaigns/campaign-type/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['CampaignTypes']
    }),
    deleteCampaignType: builder.mutation({
      query: id => ({
        url: `/campaigns/campaign-type/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CampaignTypes']
    })
  })
})

export const {
  useGetCampaignTypesQuery,
  useLazyGetCampaignTypesQuery,
  useGetCampaignTypeByIdQuery,
  useCreateCampaignTypeMutation,
  useUpdateCampaignTypeMutation,
  useDeleteCampaignTypeMutation
} = cMTypesApi
